require('./BreadCrumbs.scss');

const b = require('app/www/libs/b')('bread-crumbs');

const React = require('react');
const PropTypes = require('prop-types');

const {withReq} = require('app/www/components/contexts/Req');
const {withI18n} = require('app/www/components/contexts/I18n');

const Global = require('app/www/components/blocks/Global/Global');
const Link = require('app/www/components/blocks/Link/Link');

class BreadCrumbs extends React.PureComponent {

    constructor(props) {
        super(props);

        this._attrs = {
            itemType: 'http://data-vocabulary.org/Breadcrumb',
            itemScope: true,
        };
    }

    render() {
        const {req, i18n, items} = this.props;
        const urlBuilder = req.lib('urlBuilder');

        const region = urlBuilder.getPathRegionId()
            ? i18n.get('controllers.region', {region: Global.regionPrepositional})
            : '';

        items.unshift({
            title: i18n.get('bread-crumbs', {region}),
            url: urlBuilder.getIndexUrl({date: null, period: null}),
        });

        return (
            <div className={b()}>
                {items.map((item, index) => {
                    return (index !== items.length - 1
                        ? this._item(item, index)
                        : this._lastItem(item, index)
                    );
                })}
            </div>
        );
    }

    /**
     * @param {Object} item
     * @param {Number} index
     * @returns {Object}
     * @private
     */
    _item(item, index) {
        const attrs = Object.assign({}, this._attrs, {
            id: index,
            itemRef: index + 1,
        });

        const linkProps = {
            url: item.url,
            attrs: {
                itemProp: 'url',
            },
        };

        if (index) {
            attrs.itemProp = 'child';
        }

        return (
            <div key={item.title} className={b('item')} {...attrs}>
                <Link className={b('link')} {...linkProps}>
                    <span itemProp="title">{item.title}</span>
                </Link>
            </div>
        );
    }

    /**
     * @param {Object} item
     * @param {Number} index
     * @returns {Object}
     * @private
     */
    _lastItem(item, index) {
        const {req} = this.props;
        const url = req.lib('urlBuilder').appUrls.www.split('?')[0];
        const attrs = Object.assign({}, this._attrs, {
            itemProp: 'child',
            id: index,
        });

        return (
            <div key={item.title} className={b('item')} {...attrs}>
                <span itemProp="title" dangerouslySetInnerHTML={{__html: item.title}} />
                <meta itemProp="url" content={url} />
            </div>
        );
    }
}

BreadCrumbs.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string,
    })),
};

module.exports = withReq(withI18n(BreadCrumbs));
